module.exports = __webpack_public_path__ + "img/company.25b98798.png";